/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { flightDayWiseAvail, getCouponLogs } from '../../../api/profileApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppLink from '../../../shared/components/app-link/AppLink';
import AppModal from '../../../shared/components/app-modal/AppModal';

function DayWiseAvail({ coupoinId, onEdit }) {
  const [detailsList, setDetailsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openLogs, setOpenLogs] = useState(false);
  const [logsList, setLogsList] = useState([]);
  const logsIdRef = useRef(undefined);
  const getAvailDetails = async () => {
    setIsLoading(true);
    const res = await flightDayWiseAvail(coupoinId);
    if (res && res.Root?.Status === 'OK') {
      const { FlightDaywiseavail } = res.Root.Result;
      if (FlightDaywiseavail !== '') {
        const list = Array.isArray(FlightDaywiseavail)
          ? FlightDaywiseavail
          : [FlightDaywiseavail];
        setDetailsList(list);
      }
    } else {
      setDetailsList([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAvailDetails();
  }, [coupoinId]);

  const getLogDetails = async () => {
    setIsLoading(true);
    const response = await getCouponLogs(logsIdRef.current);
    if (response && response.Root?.Status === 'OK') {
      const { CouponLogList } = response.Root.Result;
      if (CouponLogList !== '') {
        // const list = Array.isArray(CouponLogList)
        //   ? CouponLogList
        //   : [CouponLogList];
      } else {
        setLogsList([]);
      }
    }
    setIsLoading(false);
  };

  const handleOpenLogs = (id) => {
    setLogsList([]);
    logsIdRef.current = id;
    getLogDetails();
    setOpenLogs(true);
  };

  return (
    <div className="flight-daywise-avail-modal">
      <AppLoading isLoading={isLoading} />
      {detailsList.length > 0 ? (
        <div className="overflow-auto">
          <table>
            <thead>
              <tr>
                <th>Record Id</th>
                <th>CouponId</th>
                <th>Departure Date</th>
                <th>Arrival Date</th>
                <th>Total Seats</th>
                <th>Available Seats</th>
                <th>Additional Charges</th>
                <th>Total Amount</th>
                <th>Flight Number</th>
                <th>Departure Time</th>
                <th>Arrival Time</th>
                <th>PNR</th>
                <th>InsertTime</th>
                <th>Edit</th>
                <th>Logs</th>
              </tr>
            </thead>
            <tbody>
              {detailsList.map((detail) => (
                <tr key={detail.Recordid}>
                  <td>{detail.Recordid}</td>
                  <td>{detail.CouponId}</td>
                  <td>{detail.AvailaDate}</td>
                  <td>{detail.AvailaDate}</td>
                  <td>{detail.TotalAvail}</td>
                  <td>{detail.CurrentAvail}</td>
                  <td>{detail.HandlingCharges}</td>
                  <td>{detail.TotalAmount}</td>
                  <td>{detail.FlightNumber}</td>
                  <td>{detail.DepartureTime}</td>
                  <td>{detail.ArrivalTime}</td>
                  <td>{detail.GDSPnr}</td>
                  <td>{detail.InsertTime}</td>
                  <td>
                    <AppLink
                      linkText="Edit"
                      variant="orange"
                      onClick={() => onEdit(detail.Recordid)}
                    />
                  </td>
                  <td>
                    <AppLink
                      linkText="Logs"
                      variant="orange"
                      onClick={() => handleOpenLogs(detail.Recordid)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>No Details Found</div>
      )}
      {openLogs && (
        <AppModal
          modalTitle={`Logs For Record : ${logsIdRef.current}`}
          onModalClose={() => setOpenLogs(false)}
          showCloseButton
          size="xl"
        >
          <div>
            {logsList.length > 0 ? 'Check Network' : 'NO Logs Available'}
          </div>
        </AppModal>
      )}
    </div>
  );
}

DayWiseAvail.propTypes = {
  coupoinId: PropTypes.number.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default DayWiseAvail;
